
function formatDate (date) {
    if (!date) return undefined;
    
    const dateStr = (date instanceof Date) ? date.toISOString().substr(0, 10) : date;

    const [year, month, day] = dateStr.split('-')
    return `${day}/${month}/${year}`
}

function parseSlashedDate(date) {
    if (!date) return null

    const [day, month, year] = date.split('/')
    if (!day || !month || !year) {
        return "";
    }
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
}

function formatAccount(account) {
    if (!account) return '';
    return account.obj().name;
}

function formatNumber(num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
  }

function formatAmount(amount) {
    if (!amount) return '';
    const value = amount.value.toFixed(2);

    return formatNumber(value) + " " + amount.currency.obj().symbol
}

function formatDecimal(num) {
    if (!num) return "";
    return formatNumber(num.toFixed(2));
}

function truncate(nb, str) {
    if (str.length > nb) {
        return str.substr(0, nb) + "...";
    }
    return str;

}
function truncate15(str) {
    return truncate(15, str)
}

function truncate30(str) {
    return truncate(30, str);
}

function initGlobalFilters(Vue) {
    Vue.filter("formatDate", formatDate);
    Vue.filter("formatAccount", formatAccount);
    Vue.filter("formatDecimal", formatDecimal);
    Vue.filter("formatAmount", formatAmount);
    Vue.filter("parseSlashedDate", parseSlashedDate);
    Vue.filter("truncate15", truncate15);
    Vue.filter("truncate30", truncate30);
}

export {initGlobalFilters};